import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisualValidation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_201289_91769)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M4.98514 10.5954C5.04742 10.6577 5.14988 10.6577 5.21215 10.5954L7.25724 8.55032L8.98693 10.282C9.04921 10.3443 9.15166 10.3443 9.21394 10.282L13.7601 5.73179C13.8224 5.66951 13.8224 5.56706 13.7601 5.50478L13.0209 4.76549C12.9907 4.73558 12.9499 4.71881 12.9074 4.71881C12.8648 4.71881 12.8241 4.73558 12.7939 4.76549L9.10144 8.46192L7.37175 6.73023C7.34155 6.70032 7.30076 6.68354 7.25825 6.68354C7.21574 6.68354 7.17495 6.70032 7.14474 6.73023L4.24586 9.62911C4.21595 9.65932 4.19917 9.70011 4.19917 9.74261C4.19917 9.78512 4.21595 9.82591 4.24586 9.85612L4.98514 10.5954Z",
			fill: "currentColor",
			fillOpacity: .85
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.8743 1.92885H9.72252V0.643136C9.72252 0.554743 9.6502 0.482422 9.5618 0.482422H8.4368C8.34841 0.482422 8.27609 0.554743 8.27609 0.643136V1.92885H1.1243C0.768722 1.92885 0.481445 2.21613 0.481445 2.57171V13.0181C0.481445 13.3737 0.768722 13.661 1.1243 13.661H8.28412V14.3039L4.97341 16.4755C4.95581 16.4869 4.94065 16.5017 4.92879 16.519C4.91693 16.5364 4.90862 16.5558 4.90432 16.5764C4.90003 16.5969 4.89984 16.6181 4.90377 16.6387C4.90769 16.6593 4.91566 16.679 4.9272 16.6965L5.53591 17.6447V17.6467C5.58412 17.721 5.68457 17.7411 5.7589 17.6929L8.9993 15.5675L12.2397 17.6929C12.314 17.7411 12.4145 17.721 12.4627 17.6467V17.6447L13.0714 16.6965C13.0943 16.661 13.1023 16.6179 13.0936 16.5765C13.085 16.5352 13.0604 16.4989 13.0252 16.4755L9.72252 14.3099V13.661H16.8743C17.2299 13.661 17.5172 13.3737 17.5172 13.0181V2.57171C17.5172 2.21613 17.2299 1.92885 16.8743 1.92885ZM16.0707 12.2146H1.92787V3.37528H16.0707V12.2146Z",
			fill: "currentColor",
			fillOpacity: .85
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_201289_91769",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgVisualValidation;
